import { UserRoles, UserRoleType } from 'model/UserRoleType';

export const getIsAdminOrCircleAdmin = (roles: UserRoles[]) => {
  const allowedRoles = [UserRoleType.Admin, UserRoleType.CircleAdmin];
  return allowedRoles.some((allowedRole) => roles.includes(allowedRole));
};
